import { render } from "./AddressBookInfo.vue?vue&type=template&id=820ddbac&scoped=true"
import script from "./AddressBookInfo.vue?vue&type=script&lang=js"
export * from "./AddressBookInfo.vue?vue&type=script&lang=js"

import "./AddressBookInfo.vue?vue&type=style&index=0&id=820ddbac&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-820ddbac"]])

export default __exports__